// Route guard for the authenticated app shell. A company-scoped `authToken`
// (set by select-company) means the session is ready; without it we bounce to
// /login, remembering where the user was headed so login can return them.

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';

const JWTProtectedRoute = () => {
  const authToken = useAppSelector((state) => state.auth.authToken);
  const location = useLocation();

  if (!authToken) {
    return <Navigate to='/login' replace state={{ from: location }} />;
  }
  return <Outlet />;
};

export default JWTProtectedRoute;
